export let UdemyLocale = /*#__PURE__*/function (UdemyLocale) {
  UdemyLocale["AR_SA"] = "ar_SA";
  UdemyLocale["EN_US"] = "en_US";
  UdemyLocale["DE_DE"] = "de_DE";
  UdemyLocale["ES_ES"] = "es_ES";
  UdemyLocale["FR_FR"] = "fr_FR";
  UdemyLocale["ID_ID"] = "id_ID";
  UdemyLocale["IT_IT"] = "it_IT";
  UdemyLocale["JA_JP"] = "ja_JP";
  UdemyLocale["KO_KR"] = "ko_KR";
  UdemyLocale["NL_NL"] = "nl_NL";
  UdemyLocale["PL_PL"] = "pl_PL";
  UdemyLocale["PT_BR"] = "pt_BR";
  UdemyLocale["RO_RO"] = "ro_RO";
  UdemyLocale["RU_RU"] = "ru_RU";
  UdemyLocale["TH_TH"] = "th_TH";
  UdemyLocale["TR_TR"] = "tr_TR";
  UdemyLocale["ZH_CN"] = "zh_CN";
  UdemyLocale["ZH_TW"] = "zh_TW";
  UdemyLocale["VI_VN"] = "vi_VN";
  return UdemyLocale;
}({});
export const UdemySupportedLanguages = [{
  locale: UdemyLocale.AR_SA,
  region: 'AR',
  name: 'Arabic',
  lang: 'ar'
}, {
  locale: UdemyLocale.DE_DE,
  region: 'DE',
  name: 'German',
  lang: 'de'
}, {
  locale: UdemyLocale.EN_US,
  region: 'US',
  name: 'English',
  lang: 'en'
}, {
  locale: UdemyLocale.ES_ES,
  region: 'ES',
  name: 'Spanish',
  lang: 'es'
}, {
  locale: UdemyLocale.FR_FR,
  region: 'FR',
  name: 'French',
  lang: 'fr'
}, {
  locale: UdemyLocale.ID_ID,
  region: 'ID',
  name: 'Indonesian',
  lang: 'id'
}, {
  locale: UdemyLocale.IT_IT,
  region: 'IT',
  name: 'Italian',
  lang: 'it'
}, {
  locale: UdemyLocale.JA_JP,
  region: 'JP',
  name: 'Japanese',
  lang: 'ja'
}, {
  locale: UdemyLocale.KO_KR,
  region: 'KR',
  name: 'Korean',
  lang: 'ko'
}, {
  locale: UdemyLocale.NL_NL,
  region: 'NL',
  name: 'Dutch',
  lang: 'nl'
}, {
  locale: UdemyLocale.PL_PL,
  region: 'PL',
  name: 'Polish',
  lang: 'pl'
}, {
  locale: UdemyLocale.PT_BR,
  region: 'BR',
  name: 'Portuguese',
  lang: 'pt'
}, {
  locale: UdemyLocale.RO_RO,
  region: 'RO',
  name: 'Romanian',
  lang: 'ro'
}, {
  locale: UdemyLocale.RU_RU,
  region: 'RU',
  name: 'Russian',
  lang: 'ru'
}, {
  locale: UdemyLocale.TH_TH,
  region: 'TH',
  name: 'Thai',
  lang: 'th'
}, {
  locale: UdemyLocale.TR_TR,
  region: 'TR',
  name: 'Turkish',
  lang: 'tr'
}, {
  locale: UdemyLocale.VI_VN,
  region: 'VN',
  name: 'Vietnamese',
  lang: 'vi'
}, {
  locale: UdemyLocale.ZH_CN,
  region: 'CN',
  name: 'Chinese (Simplified)',
  lang: 'zh-cn'
}, {
  locale: UdemyLocale.ZH_TW,
  region: 'TW',
  name: 'Chinese (Traditional)',
  lang: 'zh-tw'
}];
export const DEFAULT_LOCALE = UdemyLocale.EN_US;
export let CurrencyCode = /*#__PURE__*/function (CurrencyCode) {
  CurrencyCode["USD"] = "USD";
  CurrencyCode["AUD"] = "AUD";
  CurrencyCode["BRL"] = "BRL";
  CurrencyCode["CAD"] = "CAD";
  CurrencyCode["CLP"] = "CLP";
  CurrencyCode["COP"] = "COP";
  CurrencyCode["EGP"] = "EGP";
  CurrencyCode["EUR"] = "EUR";
  CurrencyCode["GBP"] = "GBP";
  CurrencyCode["IDR"] = "IDR";
  CurrencyCode["ILS"] = "ILS";
  CurrencyCode["INR"] = "INR";
  CurrencyCode["JPY"] = "JPY";
  CurrencyCode["KRW"] = "KRW";
  CurrencyCode["MXN"] = "MXN";
  CurrencyCode["MYR"] = "MYR";
  CurrencyCode["NGN"] = "NGN";
  CurrencyCode["NOK"] = "NOK";
  CurrencyCode["PEN"] = "PEN";
  CurrencyCode["PHP"] = "PHP";
  CurrencyCode["PLN"] = "PLN";
  CurrencyCode["RON"] = "RON";
  CurrencyCode["RUB"] = "RUB";
  CurrencyCode["SAR"] = "SAR";
  CurrencyCode["SGD"] = "SGD";
  CurrencyCode["THB"] = "THB";
  CurrencyCode["TRY"] = "TRY";
  CurrencyCode["TWD"] = "TWD";
  CurrencyCode["VND"] = "VND";
  CurrencyCode["ZAR"] = "ZAR";
  return CurrencyCode;
}({});
export const CountryCurrencyMapping = {
  AR: CurrencyCode.SAR,
  AT: CurrencyCode.EUR,
  AU: CurrencyCode.AUD,
  BE: CurrencyCode.EUR,
  BG: CurrencyCode.EUR,
  BR: CurrencyCode.BRL,
  CA: CurrencyCode.CAD,
  CL: CurrencyCode.CLP,
  CO: CurrencyCode.COP,
  CY: CurrencyCode.EUR,
  CZ: CurrencyCode.EUR,
  DE: CurrencyCode.EUR,
  DK: CurrencyCode.EUR,
  EE: CurrencyCode.EUR,
  EG: CurrencyCode.EGP,
  ES: CurrencyCode.EUR,
  FI: CurrencyCode.EUR,
  FR: CurrencyCode.EUR,
  GB: CurrencyCode.GBP,
  GR: CurrencyCode.EUR,
  HR: CurrencyCode.EUR,
  HU: CurrencyCode.EUR,
  ID: CurrencyCode.IDR,
  IE: CurrencyCode.EUR,
  IL: CurrencyCode.ILS,
  IN: CurrencyCode.INR,
  IT: CurrencyCode.EUR,
  JP: CurrencyCode.JPY,
  KR: CurrencyCode.KRW,
  LT: CurrencyCode.EUR,
  LU: CurrencyCode.EUR,
  LV: CurrencyCode.EUR,
  MT: CurrencyCode.EUR,
  MX: CurrencyCode.MXN,
  MY: CurrencyCode.MYR,
  NG: CurrencyCode.NGN,
  NL: CurrencyCode.EUR,
  NO: CurrencyCode.NOK,
  PE: CurrencyCode.PEN,
  PH: CurrencyCode.PHP,
  PL: CurrencyCode.PLN,
  PT: CurrencyCode.EUR,
  RO: CurrencyCode.RON,
  RU: CurrencyCode.RUB,
  SE: CurrencyCode.EUR,
  SG: CurrencyCode.SGD,
  SI: CurrencyCode.EUR,
  SK: CurrencyCode.EUR,
  TH: CurrencyCode.THB,
  TR: CurrencyCode.TRY,
  TW: CurrencyCode.TWD,
  VN: CurrencyCode.VND,
  XK: CurrencyCode.EUR,
  ZA: CurrencyCode.ZAR
};
export let Direction = /*#__PURE__*/function (Direction) {
  Direction["LTR"] = "ltr";
  Direction["RTL"] = "rtl";
  return Direction;
}({});
export const RtlLocales = [UdemyLocale.AR_SA];
//# sourceMappingURL=constants.js.map